import { Box, Container, Typography } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import * as constants from '../../config/constants'
import Button from '../../shared/Button'
import { deviceList } from '../../store/devices'

const DeviceScreen: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useDispatch<Dispatch<any>>()
  const handleDeviceList = () => {
    navigate(`/${constants.DEVICES_LIST}`)
  }
  return (
    <Container fixed maxWidth='xs'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box display='flex' justifyContent='center' sx={{ mt: 2, mb: 4 }}>
          <img alt='Logo' src='images/TinyLogo.png' />
        </Box>
        <Box display='flex' flexDirection='column' justifyContent='center' sx={{ mt: 1, mb: 1 }}>
          <Button onClick={() => navigate(`/${constants.REGISTER_DEVICE}`)}>
            {t('screens.deviceList.registerDevice_button_text')}
          </Button>
        </Box>
        <Box display='flex' flexDirection='column' justifyContent='center' sx={{ mt: 1, mb: 1 }}>
          <Button onClick={handleDeviceList}>
            {t('screens.deviceList.deviceList_button_text')}
          </Button>
        </Box>
      </Box>
    </Container>
  )
}

export default DeviceScreen
